import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const services = [
  {
    icon: "ri-tools-line",
    title: "Réparation manuel & électrique",
    desc: "Réparation de tous types de volets roulants, manuels ou motorisés, quelle que soit la marque.",
    href: "/reparation-volet-roulant",
    image:
      "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/330bec9c0805a39b67b0734a4829a4f7.webp",
    imageAlt: "Technicien réparant un volet roulant manuel et électrique à Strasbourg",
    imageWidth: 400,
    imageHeight: 160,
  },
  {
    icon: "ri-alarm-warning-line",
    title: "Dépannage urgence",
    desc: "Intervention rapide en urgence pour tout volet bloqué, coincé ou endommagé.",
    href: "/depannage-urgence",
    image:
      "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/3c467ac38c9dff1630be84d06d8e9dfc.jpeg",
    imageAlt: "Dépannage urgent de volet roulant bloqué à Strasbourg",
    imageWidth: 400,
    imageHeight: 160,
  },
  {
    icon: "ri-flashlight-line",
    title: "Remplacement de moteur",
    desc: "Remplacement de moteur Somfy, Nice, Simu et autres marques avec garantie.",
    href: "/moteur-somfy",
    image:
      "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/89fdeb7753cb62a22b3489af158b2c8a.jpeg",
    imageAlt: "Remplacement de moteur de volet roulant Somfy à Strasbourg",
    imageWidth: 400,
    imageHeight: 160,
  },
  {
    icon: "ri-scissors-cut-line",
    title: "Sangle, cordon & tablier",
    desc: "Changement de sangle, cordon de tirage, ou réparation de lames de tablier.",
    href: "/sangle-volet-roulant",
    image:
      "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a7d1074c195112eef230e01645455738.jpeg",
    imageAlt: "Remplacement de sangle et tablier de volet roulant à Strasbourg",
    imageWidth: 400,
    imageHeight: 160,
  },
  {
    icon: "ri-remote-control-line",
    title: "Motorisation & électrification",
    desc: "Transformation de votre volet manuel en électrique avec motorisation adaptée.",
    href: "/motorisation-somfy",
    image:
      "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/b83e62e2f9593b654bef4bf31b649f3e.jpeg",
    imageAlt: "Motorisation et électrification de volet roulant à Strasbourg",
    imageWidth: 400,
    imageHeight: 160,
  },
  {
    icon: "ri-add-circle-line",
    title: "Pose & installation de volet neuf",
    desc: "Installation complète de volets roulants neufs sur mesure pour votre habitat.",
    href: "/pose-volet-roulant",
    image:
      "https://readdy.ai/api/search-image?query=Fresh%20installation%20of%20a%20new%20white%20roller%20shutter%20on%20a%20modern%20French%20house%20window%2C%20complete%20setup%20with%20aluminum%20frame%2C%20bright%20daylight%20exterior%20view%2C%20professional%20installation%20work%2C%20clean%20aesthetic%2C%20realistic%20photography&width=400&height=160&seq=svc-pose&orientation=landscape",
    imageAlt: "Pose et installation de volet roulant neuf à Strasbourg",
    imageWidth: 400,
    imageHeight: 160,
  },
];

export default function Services() {
  return (
    <section id="réparation" className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <p className="text-brand-text/60 text-xs font-medium uppercase tracking-wider mb-2">
          Nos prestations
        </p>
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-8 md:mb-12">
          Nos services de <strong className="text-brand-blue">réparation de volet roulant</strong>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((s) => (
            <a
              key={s.title}
              href={s.href}
              className="block bg-white rounded-xl overflow-hidden border border-brand-border hover:border-brand-cyan/40 transition-colors group"
            >
              {/* Image d'illustration */}
              <div className="w-full h-40 overflow-hidden">
              <ImagePlaceholder
                src={s.image}
                alt={s.imageAlt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
                width={s.imageWidth}
                height={s.imageHeight}
              />
              </div>

              {/* Contenu */}
              <div className="p-6 md:p-7">
                <div className="w-10 h-10 flex items-center justify-center mb-4">
                  <i className={`${s.icon} text-brand-blue text-3xl`}></i>
                </div>
                <h3 className="text-brand-blue text-lg font-bold mb-2">
                  {s.title}
                </h3>
                <p className="text-brand-text text-sm leading-relaxed mb-4">
                  {s.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-brand-blue text-sm font-semibold hover:text-brand-cyan transition-colors group-hover:gap-2">
                  En savoir plus
                  <i className="ri-arrow-right-line text-sm transition-all"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}